import * as React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { useRef, useEffect } from "react";
import { DateTime } from "enums";
import { formatDate, parseDate } from "react-day-picker/moment";
import classNames from "classnames";
import styles from "./date-picker.module.scss";
import { Calendar } from "images";
import Image from "../image/image";
import moment from "moment";
import { useMemo } from "react";

const DatePicker = ({
  value,
  onChange,
  name,
  disabled,
  error,
  placeholder,
  className,
  disableStartDate,
  disableEndDate,
  allowPastDates,
}) => {
  const datePickerRef = useRef();

  useEffect(() => {
    if (!value) {
      console.log(datePickerRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const modifiers = useMemo(() => {
    let modifiers = null;
    let disabled = [];
    if (disableStartDate) {
      disabled.push({
        before: new Date(disableStartDate),
      });
    }
    if (disableEndDate) {
      disabled.push({
        after: new Date(disableEndDate),
      });
    }

    if (disabled.length) {
      modifiers = { disabled };
    }
    return modifiers;
  }, [disableStartDate, disableEndDate]);

  return (
    <div
      className={classNames(styles.container, className, {
        [`${styles.disabled}`]: disabled,
        [`${styles.error}`]: error,
      })}
    >
      <div className={styles.datePicker}>
        {disabled ? (
          <div>{value ? moment(value).format(DateTime.A) : placeholder}</div>
        ) : (
          <DayPickerInput
            ref={datePickerRef}
            value={value}
            placeholder={placeholder}
            format={DateTime.A}
            formatDate={formatDate}
            parseDate={parseDate}
            inputProps={{
              onChange: (e) => {
                if (e.target.value.length > 11) {
                  const today = moment();
                  const todayFormatted = today.format(DateTime.A);
                  datePickerRef.current.getInput().value = todayFormatted;
                  onChange(name, { value: today.toDate() });
                }
              },
              onBlur: () => {
                const inputValue = datePickerRef.current.getInput().value.trim();
                const date = moment(inputValue, "D MMM YYYY");

                if (!date.isValid()) return;

                if (disableStartDate && date.isBefore(moment(disableStartDate))) {
                  onChange(name, { value: disableStartDate });
                } else if (disableEndDate && date.isAfter(moment(disableEndDate))) {
                  onChange(name, { value: disableEndDate });
                }
              },
            }}
            onDayChange={(date) => {
              // if (!disabled) {
              //   const today = moment().startOf("day");
              //   if (moment(date).isBefore(today)) {
              //     const todayFormatted = today.format(DateTime.A);
              //     datePickerRef.current.getInput().value = todayFormatted;
              //     onChange(name, { value: today.toDate() });
              //     return;
              //   }
              //   onChange(name, { value: date });
              // }

              onChange(name, { value: date });
            }}
            onBlur={() => {
              const inputValue = datePickerRef.current.getInput().value.trim();
              const today = moment().startOf("day");

              if (inputValue.length > 11) {
                if (!allowPastDates) {
                  const todayFormatted = today.format(DateTime.A);
                  datePickerRef.current.getInput().value = todayFormatted;
                  onChange(name, { value: today.toDate() });
                }
                return;
              }

              const parsedDate = moment(inputValue, DateTime.A, true);
              const isAfterEndDate =
                disableEndDate && parsedDate.isAfter(moment(disableEndDate).endOf("day"));
              if (
                !parsedDate.isValid() ||
                (!allowPastDates && parsedDate.isBefore(today)) ||
                isAfterEndDate
              ) {
                const resetDate = isAfterEndDate ? moment(disableEndDate) : today;
                datePickerRef.current.getInput().value = resetDate.format(DateTime.A);
                onChange(name, { value: resetDate.toDate() });
              }
            }}
            disabled={disabled}
            dayPickerProps={{
              disabled: modifiers?.disabled,
              numberOfMonths: 1,
              modifiers: modifiers,
            }}
          />
        )}
        <Image
          className={styles.icon}
          src={Calendar}
          onClick={() => datePickerRef.current?.getInput().focus()}
        />
      </div>
    </div>
  );
};

export default DatePicker;
